module.exports = __webpack_public_path__ + "img/excel.eaaa3662.png";